export const noAdditionalLessonConfigurationColor = '#FB4C5F';
